module.exports = __webpack_public_path__ + "static/media/pauseBtn.3c9d6084.png";